import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { getImg } from '../../Api/getImg';

export default function DoctorImage({ photoId }) {
    const [imgLoaded, setImgLoaded] = useState(false);
    const [imgError, setImgError] = useState(false);

    const placeholder = 'https://via.placeholder.com/160?text=Loading...';
    const src = imgError ? placeholder : getImg(photoId);

    return (
        <div className=" w-full max-w-[250px] items-center justify-center flex aspect-square sm:max-w-md  sm:aspect-[4/5] md:max-w-md lg:max-w-xl sm:max-h-[450px] mx-auto relative overflow-hidden rounded-full sm:rounded-2xl drop-shadow  xl:ps-32 xl:me-32">
            <motion.img
                src={src}
                alt="Doctor"
                loading="lazy"
                onLoad={() => setImgLoaded(true)}
                onError={() => setImgError(true)}
                className={`w-full h-full  object-contain object-center rounded-full   sm:rounded-full drop-shadow transition-opacity duration-700 ease-in-out ${imgLoaded ? 'opacity-100' : 'opacity-0'}`}
                initial={{
                    y: 100,      // Start 100px below
                    opacity: 0,
                    scale: 0.9,  // Slightly smaller at start
                }}
                animate={{
                    y: imgLoaded ? 0 : 100,  // Slide up when loaded
                    opacity: imgLoaded ? 1 : 0,
                    scale: 1,    // Normal size when loaded
                }}
                transition={{
                    type: 'spring',
                    stiffness: 100,
                    damping: 15,
                    mass: 0.5,
                    delay: 0.2,
                }}
                whileHover={{
                    scale: 1.02,
                    transition: { duration: 0.3 },
                }}
            />

        </div>
    );
}